import { initialState } from "../initialState";
import { STORE_FOOD_AND_REC_URLS, CLEAR_FOOD_AND_REC_URLS } from "../actions";

export default function saveFoodNRecURLS(
  state = initialState.foodNRecURLS,
  action
) {
  switch (action.type) {
    case STORE_FOOD_AND_REC_URLS:
      return action.payload;
    case CLEAR_FOOD_AND_REC_URLS:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/saveFoodNRecURLS.js